export enum PageTab {
  Details = 'details',
  ClientTeam = 'client-team',
  Team = 'team',
  FeeSchedule = 'fee-schedule',
  Conflicts = 'conflicts',
  Policies = 'policies',
  Discount = 'discount'
}
